import omit from 'lodash/omit'
import { call, put, takeLatest } from 'redux-saga/effects'
import {
  LOAD_REPORT,
  LOAD_REPORT_PREVIEW,
  LOAD_REPORT_VERIFICATION,
  loadReportFailed,
  loadReportFinished,
  loadReportVerificationFailed,
  loadReportVerificationFinished
} from 'store/actions/reportAction'
import { fetchReport, putReportVerification } from 'api/reportApi'
import { fetchSearchConfig } from 'api/searchApi'
import { loadCopyright, loadDisclaimer } from 'store/actions/clapiAction'
import { PREVIEW_DATA_REPORT_AU, PREVIEW_DATA_REPORT_NZ } from 'constants/previewReportData'
import { Country } from 'utils/constants'
import { DEFAULT_AVM_DISPLAY_TYPE_BY_COUNTRY } from 'constants/valuationEstimatesConstant'
import { v4 as uuidv4 } from 'uuid'

// WORKERS //
export function * loadReportHandler(action) {
  const code = action.payload

  try {
    const response = yield call(fetchReport, code)
    const data = response.data

    yield put(loadDisclaimer(code))
    yield put(loadCopyright(code))
    yield put(loadReportFinished(data))
  } catch (e) {
    yield put(loadReportFailed(e.name, e.message))
  }
}

export function * loadReportVerificationHandler(action) {
  const code = action.payload

  try {
    yield call(putReportVerification, code)

    yield put(loadReportVerificationFinished())
  } catch (e) {
    yield put(loadReportVerificationFailed(e.name, e.message))
  }
}

export function * loadReportPreviewHandler(action) {
  const { countryCode, integratorShortName } = action.payload
  try {
    let preferences

    if (integratorShortName) {
      const { data } = yield call(fetchSearchConfig, integratorShortName, countryCode)

      // catch downstream service errors in the API
      if (data.errors && data.errors.length > 0) {
        yield put(loadReportFailed('Config API', data.errors))
        return
      }

      preferences = data.preferences
      sessionStorage.setItem('integratorName', data.integratorName)
    }

    const initialReportData = countryCode === Country.AU ? PREVIEW_DATA_REPORT_AU : PREVIEW_DATA_REPORT_NZ

    const reportProperties = preferences
      ? {
        ...initialReportData,
        preference: {
          ...createPreferenceObject(preferences),
          avmDisplayType: DEFAULT_AVM_DISPLAY_TYPE_BY_COUNTRY[countryCode]
        }
      }
      : { ...initialReportData }

    sessionStorage.setItem('countryCode', countryCode)
    sessionStorage.setItem('sessionId', uuidv4())

    yield put(loadReportFinished(reportProperties))
  } catch (e) {
    yield put(loadReportFailed(e.name, e.message))
  }
}

// UTILS //
export function createPreferenceObject(preferences = {}) {
  const omitProps = ['leadGenTitle', 'leadGenTextBelowTitle',
    'buttonColor', 'buttonTextColor', 'additionalInfoTextColor',
    'heroImageUrlDesktop', 'heroImageUrlMobile', 'reportDisclaimer',
    'reportHeaderLogoUrl'
  ]

  const preference = {
    ...preferences,
    headerLogoUrl: preferences.reportHeaderLogoUrl,
    headerBackgroundColor: preferences.reportHeaderBackgroundColor,
    bodyBackgroundColor: preferences.reportBodyBackgroundColor,
    footerBackgroundColor: preferences.reportFooterBackgroundColor,
    footerFontColor: preferences.reportFooterFontColor,
    headerFontColor: preferences.reportHeaderFontColor,
    footerLogoUrl: preferences.footerLogoUrl,
    disclaimer: preferences.reportDisclaimer
  }

  return { ...omit(preference, omitProps) }
}

// WATCHER //
export default function * watchReportSaga() {
  yield takeLatest(LOAD_REPORT, loadReportHandler)
  yield takeLatest(LOAD_REPORT_VERIFICATION, loadReportVerificationHandler)
  yield takeLatest(LOAD_REPORT_PREVIEW, loadReportPreviewHandler)
}
